import React from "react";
import marked from "marked";
import dompurify from "dompurify";
import {useTypedSelector} from "../hooks/useTypeSelector";
import {i18n} from "../helpers/localisation-helpers";

const ProductBullets = () => {
    const {  productData } = useTypedSelector((state) => state.product);

    if(productData == undefined) {
        return null;
    }
    
    if(productData.Bullets.length == 0) {
        return null;
    }
    
    //Check if the bullets array is just an array of empty strings
    let allBulletsEmpty = true;
    productData.Bullets.forEach((bullet) => {
        if(bullet != "") {
            allBulletsEmpty = false;
        }
    });
    
    if(allBulletsEmpty) {
        return null;
    }
    
    return (
        <div className="product-bullets">
            <div className="onepcssgrid-1300">
                <div className="onerow">
                    <div className="col12 last">
                        <h2><a id="features">{i18n("Resource.Features", productData.PageLocalisations)}</a></h2>
                    </div>
                </div>
                <div className="onerow">
                    <nav className="col12 last container">

                        
                        {productData.Bullets.length > 0 && productData.Bullets.map((keyFeature, index) => {
                           return (
                                 <div className="key-feature" key={index}>
                                    <div dangerouslySetInnerHTML={{__html: dompurify.sanitize(marked.parse(keyFeature))}}></div>
                                </div>
                           )
                        })}

                    </nav>
                </div>
            </div>
        </div>
    )
}

export default ProductBullets;